<script lang="ts">export let size = "20";
const height = size;
</script>

<svg
	{height}
	style="fill: currentColor"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 28.35 28.35"
>
	<g>
		<path
			d="m9.14 8.65-2.58 2.58c-.47.47-.47 1.23 0 1.71.47.47 1.23.47 1.71 0l.29-.29c.33-.33.85-.33 1.17 0l.29.29c.47.47 1.23.47 1.71 0 .47-.47.47-1.23 0-1.71L9.15 8.65Z"
		/>
		<path
			d="M14.95 15.89c0-1.66 1.21-2.91 3.32-3.59V2.49c0-1.37-1.12-2.49-2.49-2.49H2.49C1.12 0 0 1.12 0 2.49v21.04c0 1.37 1.12 2.49 2.49 2.49h12.46V15.88ZM4.43 5.26c0 .46-.37.83-.83.83s-.83-.37-.83-.83V3.6c0-.46.37-.83.83-.83s.83.37.83.83v1.66Zm8.46 8.85c-.79.79-1.93 1.02-2.92.69v1.81h1.38c.46 0 .83.37.83.83s-.37.83-.83.83H6.92c-.46 0-.83-.37-.83-.83s.37-.83.83-.83H8.3v-1.8c-.29.09-.59.14-.9.14-.74 0-1.47-.28-2.03-.84a2.86 2.86 0 0 1 0-4.05l3.17-3.17c.33-.33.85-.33 1.17 0l3.17 3.17a2.86 2.86 0 0 1 0 4.05Z"
		/>
		<path
			d="M22.48 18.38c-2.92 0-5.87-.77-5.87-2.49s2.95-2.49 5.87-2.49 5.87.77 5.87 2.49-2.95 2.49-5.87 2.49ZM22.48 20.04c-2.55 0-4.57-.48-5.87-1.33v2.16c0 1.72 2.95 2.49 5.87 2.49s5.87-.77 5.87-2.49v-2.16c-1.3.86-3.32 1.33-5.87 1.33ZM22.48 25.02c-2.55 0-4.57-.48-5.87-1.33v2.16c0 1.72 2.95 2.49 5.87 2.49s5.87-.77 5.87-2.49v-2.16c-1.3.86-3.32 1.33-5.87 1.33Z"
		/>
	</g>
</svg>
